import { SIZES_JSON } from '@eventbrite/eds-iconography';

export const getPaymentIconSizeWidth = (size) =>
    SIZES_JSON[`payment-icon-width-${size}`];
export const getPaymentIconSizeHeight = (size) =>
    SIZES_JSON[`payment-icon-height-${size}`];
